import { render, staticRenderFns } from "./right_structure.vue?vue&type=template&id=0e8a23aa&scoped=true"
import script from "./right_structure.vue?vue&type=script&lang=js"
export * from "./right_structure.vue?vue&type=script&lang=js"
import style0 from "./right_structure.vue?vue&type=style&index=0&id=0e8a23aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a23aa",
  null
  
)

export default component.exports